import React from 'react'
import CustomCards from './CustomCard'
import { selectTotals } from './reports.selectors'
import { useSelector } from 'react-redux'
import { CARD_TITLE } from './reports.constants'
import BusyIndicator, { REGIONS } from '../../widgets/busyIndicator'
import { isEmpty } from 'lodash'
import StatsCard from '@/components/cards/StatsCard'
import DashboardCard from '../../components/cards/DashboardCard'

const Totals = () => {
	const totals = useSelector(selectTotals)

	const {
		totalAccounts,
		previousTotalAccounts,
		totalFfl,
		previousTotalFfl,
		totalDocuments,
		previousTotalDocuments,
		totalATFAudits,
		previousTotalATFAudits,
		totalATFAuditors,
		previousTotalATFAuditors,
		totalGreenFlaggedByFfl,
		previousTotalGreenFlaggedByFfl,
		totalYellowFlaggedByFfl,
		previousTotalYellowFlaggedByFfl,
		totalRedFlaggedByFfl,
		previousTotalRedFlaggedByFfl,
		totalGreenFlaggedByAtf,
		previousTotalGreenFlaggedByAtf,
		totalYellowFlaggedByAtf,
		previousTotalYellowFlaggedByAtf,
		totalRedFlaggedByAtf,
		previousRedFlaggedByAtf,
	} = totals

	const totalsCards = [
		{
			title: 'Total Accounts',
			currentValue: totalAccounts,
			previousValue: previousTotalAccounts,
		},
		{
			title: 'Total FFLs',
			currentValue: totalFfl,
			previousValue: previousTotalFfl,
		},
		{
			title: 'Total Documents',
			currentValue: totalDocuments,
			previousValue: previousTotalDocuments,
		},
		{
			title: 'Total ATF Audits',
			currentValue: totalATFAudits,
			previousValue: previousTotalATFAudits,
		},
		{
			title: 'Total ATF Auditors',
			currentValue: totalATFAuditors,
			previousValue: previousTotalATFAuditors,
		},
		{
			title: 'Total Green Flags by FFLs',
			currentValue: totalGreenFlaggedByFfl,
			previousValue: previousTotalGreenFlaggedByFfl,
		},
		{
			title: 'Total Green Flags by ATF',
			currentValue: totalGreenFlaggedByAtf,
			previousValue: previousTotalGreenFlaggedByAtf,
		},
		{
			title: 'Total Yellow Flags by FFLs',
			currentValue: totalYellowFlaggedByFfl,
			previousValue: previousTotalYellowFlaggedByFfl,
		},
		{
			title: 'Total Yellow Flags by ATF',
			currentValue: totalYellowFlaggedByAtf,
			previousValue: previousTotalYellowFlaggedByAtf,
		},
		{
			title: 'Total Red Flags by FFLs',
			currentValue: totalRedFlaggedByFfl,
			previousValue: previousTotalRedFlaggedByFfl,
		},
		{
			title: 'Total Red Flags by ATF',
			currentValue: totalRedFlaggedByAtf,
			previousValue: previousRedFlaggedByAtf,
		},
	]

	return (
		<DashboardCard title='Totals'>
			<BusyIndicator region={REGIONS.FETCH_TOTALS}>
				{!isEmpty(totals) && (
					<div className=' flex flex-row justify-between'>
						<CustomCards
							cards={totalsCards}
							cardTitle={CARD_TITLE.TOTALS}
							totals={totals}
						/>
					</div>
				)}
			</BusyIndicator>
		</DashboardCard>

	)
}

export default Totals
